// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul:not(.vertical) {
  background-color: #f1f1f1;
  border: 1px solid #d4d4d4;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
  margin-bottom: 15px;
}
ul:not(.vertical):before {
  position: absolute;
}
@media (min-width: 768px) {
  ul:not(.vertical):after {
    display: block;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 138px;
    height: 47px;
    border-top: 1px solid #d4d4d4;
    border-bottom: 1px solid #d4d4d4;
    z-index: 11;
    content: " ";
  }
}
ul:not(.vertical) li {
  position: relative;
  float: left;
  height: 46px;
  display: inline-block;
  text-align: center;
  padding: 0 20px 0 30px;
  margin: 0;
  font-size: 16px;
  line-height: 46px;
  background-color: #f9f9f9;
}
@media (max-width: 767px) {
  ul:not(.vertical) li {
    width: 100%;
    padding: 0;
    box-sizing: content-box;
    border-bottom: 1px solid #d4d4d4;
  }
  ul:not(.vertical) li:last-child {
    box-sizing: border-box;
  }
}
ul:not(.vertical) li a {
  color: #2695ce;
  padding: 0;
}
ul:not(.vertical) li a:hover {
  background-color: transparent;
}
ul:not(.vertical) li:before {
  position: absolute;
  display: block;
  border: 24px solid transparent;
  z-index: 1;
  content: "";
}
@media (max-width: 767px) {
  ul:not(.vertical) li:before {
    border-top: 8px solid #d4d4d4;
    border-bottom: 0;
    left: 50%;
    margin-left: -24px;
    bottom: -9px;
  }
}
@media (min-width: 768px) {
  ul:not(.vertical) li:before {
    border-left: 16px solid #d4d4d4;
    border-right: 0;
    top: -1px;
    right: -16px;
  }
}
ul:not(.vertical) li:after {
  position: absolute;
  display: block;
  z-index: 1;
  content: "";
  border: 24px solid transparent;
}
@media (max-width: 767px) {
  ul:not(.vertical) li:after {
    border-top: 8px solid #f9f9f9;
    border-bottom: 0;
    left: 50%;
    margin-left: -24px;
    bottom: -8px;
  }
}
@media (min-width: 768px) {
  ul:not(.vertical) li:after {
    border-left: 16px solid #f9f9f9;
    border-right: 0;
    top: -1px;
    right: -15px;
  }
}
@media (max-width: 767px) {
  ul:not(.vertical) li.disabled:after {
    border-top: 8px solid #f9f9f9;
  }
}
@media (min-width: 768px) {
  ul:not(.vertical) li.disabled:after {
    border-left: 16px solid #f9f9f9;
  }
}
ul:not(.vertical) li.disabled a, ul:not(.vertical) li.disabled a:active, ul:not(.vertical) li.disabled a:visited, ul:not(.vertical) li.disabled a:focus {
  color: #999999;
  background: #f9f9f9;
}
@media (max-width: 767px) {
  ul:not(.vertical) li:last-child {
    margin-bottom: -1px;
  }
}
ul:not(.vertical) li.active {
  background: #1E95D3;
}
@media (max-width: 767px) {
  ul:not(.vertical) li.active:after {
    border-top: 8px solid #1E95D3;
  }
}
@media (min-width: 768px) {
  ul:not(.vertical) li.active:after {
    border-left: 16px solid #1E95D3;
  }
}
ul:not(.vertical) li.active a, ul:not(.vertical) li.active a:active, ul:not(.vertical) li.active a:visited, ul:not(.vertical) li.active a:focus {
  color: #fff;
  background: #1E95D3;
}
ul:not(.vertical) li.label-on-two-lines {
  max-width: 150px;
  line-height: 1.2;
  padding-top: 4px;
}
ul:not(.vertical) .active ~ li {
  color: #999999;
  background: #f9f9f9;
}
@media (max-width: 767px) {
  ul:not(.vertical) .active ~ li:after {
    border-top: 8px solid #f9f9f9;
  }
}
@media (min-width: 768px) {
  ul:not(.vertical) .active ~ li:after {
    border-left: 16px solid #f9f9f9;
  }
}
ul.vertical {
  background-color: #f1f1f1;
  border: 1px solid #d4d4d4;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
  margin-bottom: 15px;
}
ul.vertical:before {
  position: absolute;
}
ul.vertical li {
  position: relative;
  float: left;
  height: 46px;
  display: inline-block;
  text-align: center;
  padding: 0 20px 0 30px;
  margin: 0;
  font-size: 16px;
  line-height: 46px;
  background-color: #f9f9f9;
  width: 100%;
  padding: 0;
  box-sizing: content-box;
  border-bottom: 1px solid #d4d4d4;
}
ul.vertical li:last-child {
  box-sizing: border-box;
}
ul.vertical li a {
  color: #2695ce;
  padding: 0;
}
ul.vertical li a:hover {
  background-color: transparent;
}
ul.vertical li:before {
  position: absolute;
  display: block;
  border: 24px solid transparent;
  z-index: 1;
  content: "";
  border-top: 8px solid #d4d4d4;
  border-bottom: 0;
  left: 50%;
  margin-left: -24px;
  bottom: -9px;
}
ul.vertical li:after {
  position: absolute;
  display: block;
  z-index: 1;
  content: "";
  border: 24px solid transparent;
  border-top: 8px solid #f9f9f9;
  border-bottom: 0;
  left: 50%;
  margin-left: -24px;
  bottom: -8px;
}
ul.vertical li.disabled:after {
  border-top: 8px solid #f9f9f9;
}
ul.vertical li.disabled a, ul.vertical li.disabled a:active, ul.vertical li.disabled a:visited, ul.vertical li.disabled a:focus {
  color: #999999;
  background: #f9f9f9;
}
ul.vertical li:last-child {
  margin-bottom: -1px;
}
ul.vertical li.active {
  background: #1E95D3;
}
ul.vertical li.active:after {
  border-top: 8px solid #1E95D3;
}
ul.vertical li.active a, ul.vertical li.active a:active, ul.vertical li.active a:visited, ul.vertical li.active a:focus {
  color: #fff;
  background: #1E95D3;
}
ul.vertical .active ~ li {
  color: #999999;
  background: #f9f9f9;
}
ul.vertical .active ~ li:after {
  border-top: 8px solid #f9f9f9;
}
ul.horizontal {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}
ul.horizontal.active {
  color: #000000;
}
ul.horizontal li {
  list-style-type: none;
  font-size: 12px;
  width: 12%;
  float: left;
  position: relative;
  text-align: center;
}
ul.horizontal #creditCard:before {
  font-family: "Font Awesome 7 Free";
  font-size: 900;
  content: "\\f023";
}
ul.horizontal #eft:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f023";
}
ul.horizontal #pricing:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f007";
}
ul.horizontal #identification:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f09e";
}
ul.horizontal #shareholder:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f001";
}
ul.horizontal #configuration:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f002";
}
ul.horizontal #usageFees:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f003";
}
ul.horizontal #appendicesSignature:before {
  font-size: 900;
  font-family: "Font Awesome 7 Free";
  content: "\\f004";
}
ul.horizontal li:before {
  width: 50px;
  height: 50px;
  line-height: 45px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}
ul.horizontal li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 25px;
  z-index: -1;
}
ul.horizontal li.active:before,
ul.horizontal li.active:after {
  background: skyblue;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_shared/U2000_components/U2000_navwizard/U2000_navwizard.component.scss","webpack://./src/app/U2000_style/_U2000_style-variables.scss"],"names":[],"mappings":"AAKI;EACI,yBAAA;EACA,yBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAMQ;EACI,kBAAA;AAJZ;AAMQ;EACE;IACI,cAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,UAAA;IACA,YAAA;IACA,6BAAA;IACA,gCAAA;IACA,WAAA;IACA,YAAA;EAJZ;AACF;AAMQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAJZ;AAKY;EAXJ;IAYQ,WAAA;IACA,UAAA;IACA,uBAAA;IACA,gCAAA;EAFd;EAGc;IACI,sBAAA;EADlB;AACF;AAIY;EACI,cCxBK;EDyBL,UAAA;AAFhB;AAIY;EACI,6BAAA;AAFhB;AAIY;EACI,kBAAA;EACA,cAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;AAFhB;AAGgB;EANJ;IAOQ,6BAAA;IACA,gBAAA;IACA,SAAA;IACA,kBAAA;IACA,YAAA;EAAlB;AACF;AACgB;EAbJ;IAcQ,+BAAA;IACA,eAAA;IACA,SAAA;IACA,YAAA;EAElB;AACF;AAAY;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,8BAAA;AAEhB;AADgB;EANJ;IAOQ,6BAAA;IACA,gBAAA;IACA,SAAA;IACA,kBAAA;IACA,YAAA;EAIlB;AACF;AAHgB;EAbJ;IAcQ,+BAAA;IACA,eAAA;IACA,SAAA;IACA,YAAA;EAMlB;AACF;AAFgB;EADJ;IAEQ,6BAAA;EAKlB;AACF;AAJgB;EAJJ;IAKQ,+BAAA;EAOlB;AACF;AAJY;EAII,cAAA;EACA,mBAAA;AAGhB;AAAY;EACI;IACI,mBAAA;EAElB;AACF;AACY;EACI,mBC9GQ;AD+GxB;AAEgB;EADJ;IAEQ,6BAAA;EAClB;AACF;AAAgB;EAJJ;IAKQ,+BAAA;EAGlB;AACF;AADY;EAII,WAAA;EACA,mBC7HQ;AD6HxB;AAGY;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;AADhB;AAKQ;EACI,cAAA;EACA,mBAAA;AAHZ;AAMY;EADJ;IAEQ,6BAAA;EAHd;AACF;AAIY;EAJJ;IAKQ,+BAAA;EADd;AACF;AAKI;EACI,yBAAA;EACA,yBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKQ;EACI,kBAAA;AAHZ;AAKQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EAEA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,gCAAA;AAJZ;AAKY;EACI,sBAAA;AAHhB;AAOY;EACI,cCzKK;ED0KL,UAAA;AALhB;AAOY;EACI,6BAAA;AALhB;AAOY;EACI,kBAAA;EACA,cAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;EACI,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AALpB;AAQY;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,8BAAA;EAEI,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAPpB;AAWY;EAEQ,6BAAA;AAVpB;AAcY;EAII,cAAA;EACA,mBAAA;AAfhB;AAkBY;EACI,mBAAA;AAhBhB;AAoBY;EACI,mBC9OQ;AD4NxB;AAoBY;EACO,6BAAA;AAlBnB;AAqBY;EAII,WAAA;EACA,mBCzPQ;ADmOxB;AAgCQ;EACI,cAAA;EACA,mBAAA;AA9BZ;AAgCQ;EACQ,6BAAA;AA9BhB;AAmCI;EAEI,mBAAA;EACA,gBAAA;EACA,gBAAA;AAlCR;AAoCQ;EACI,cAAA;AAlCZ;AAqCQ;EACI,qBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAnCZ;AAsCQ;EACI,kCAAA;EACA,cAAA;EACA,gBAAA;AApCZ;AAsCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AApCZ;AAuCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AArCZ;AAwCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AAtCZ;AAyCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AAvCZ;AAyCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AAvCZ;AAyCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AAvCZ;AAyCQ;EACI,cAAA;EACA,kCAAA;EACA,gBAAA;AAvCZ;AA0CQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;AAxCZ;AA2CQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAzCZ;AA4CQ;;EAEI,mBAAA;AA1CZ","sourcesContent":["\n@import \"../../../U2000_style/U2000_style-variables\";\n@import \"../../../U2000_style/U2000_style-mixins\";\n\nul {\n    &:not(.vertical) {\n        background-color: #f1f1f1;\n        border: 1px solid #d4d4d4;\n        -webkit-border-radius: 6px;\n        -moz-border-radius: 6px;\n        border-radius: 3px;\n        position: relative;\n        overflow: hidden;\n        margin-bottom: 15px;\n\n        &:before {\n            position: absolute;\n        }\n        @media (min-width: 768px) {\n          &:after {\n              display: block;\n              position: absolute;\n              left: 0px;\n              right: 0px;\n              top: 138px;\n              height: 47px;\n              border-top: 1px solid #d4d4d4;\n              border-bottom: 1px solid #d4d4d4;\n              z-index: 11;\n              content: \" \";\n          }\n        }\n        li {\n            position: relative;\n            float: left;\n            height: 46px;\n            display: inline-block;\n            text-align: center;\n            padding: 0 20px 0 30px;\n            margin: 0;\n            font-size: 16px;\n            line-height: 46px;\n            background-color: #f9f9f9;\n            @media (max-width: 767px) {\n                width: 100%;\n                padding: 0;\n                box-sizing: content-box;\n                border-bottom: 1px solid #d4d4d4;\n                &:last-child {\n                    box-sizing: border-box;\n                }\n            }\n\n            a {\n                color: $ac-text-color-blue;\n                padding: 0;\n            }\n            a:hover {\n                background-color: transparent;\n            }\n            &:before {\n                position: absolute;\n                display: block;\n                border: 24px solid transparent;\n                z-index: 1;\n                content: '';\n                @media (max-width: 767px) {\n                    border-top: 8px solid #d4d4d4;\n                    border-bottom: 0;\n                    left: 50%;\n                    margin-left: -24px;\n                    bottom: -9px;\n                }\n                @media (min-width: 768px) {\n                    border-left: 16px solid #d4d4d4;\n                    border-right: 0;\n                    top: -1px;\n                    right: -16px;\n                }\n            }\n            &:after {\n                position: absolute;\n                display: block;\n                z-index: 1;\n                content: '';\n                border: 24px solid transparent;\n                @media (max-width: 767px) {\n                    border-top: 8px solid #f9f9f9;\n                    border-bottom: 0;\n                    left: 50%;\n                    margin-left: -24px;\n                    bottom: -8px;\n                }\n                @media (min-width: 768px) {\n                    border-left: 16px solid #f9f9f9;\n                    border-right: 0;\n                    top: -1px;\n                    right: -15px;\n                }\n            }\n\n            &.disabled:after {\n                @media (max-width: 767px) {\n                    border-top: 8px solid #f9f9f9;\n                }\n                @media (min-width: 768px) {\n                    border-left: 16px solid #f9f9f9;\n                }\n            }\n\n            &.disabled a,\n            &.disabled a:active,\n            &.disabled a:visited,\n            &.disabled a:focus {\n                color: #999999;\n                background: #f9f9f9;\n            }\n\n            @media (max-width: 767px) {\n                &:last-child {\n                    margin-bottom: -1px\n                }\n            }\n\n            &.active {\n                background: $ac-color-primary-blue;\n            }\n            &.active:after {\n                @media (max-width: 767px) {\n                    border-top: 8px solid $ac-color-primary-blue;\n                }\n                @media (min-width: 768px) {\n                    border-left: 16px solid $ac-color-primary-blue;\n                }\n            }\n            &.active a,\n            &.active a:active,\n            &.active a:visited,\n            &.active a:focus {\n                color: #fff;\n                background: $ac-color-primary-blue;\n            }\n\n            &.label-on-two-lines {\n                max-width: 150px;\n                line-height: 1.2;\n                padding-top: 4px;\n            }\n        }\n\n        .active ~ li {\n            color: #999999;\n            background: #f9f9f9;\n        }\n        .active ~ li:after {\n            @media (max-width: 767px) {\n                border-top: 8px solid #f9f9f9;\n            }\n            @media (min-width: 768px) {\n                border-left: 16px solid #f9f9f9;\n            }\n        }\n    }\n\n    &.vertical {\n        background-color: #f1f1f1;\n        border: 1px solid #d4d4d4;\n        -webkit-border-radius: 6px;\n        -moz-border-radius: 6px;\n        border-radius: 3px;\n        position: relative;\n        overflow: hidden;\n        margin-bottom: 15px;\n\n        &:before {\n            position: absolute;\n        }\n        li {\n            position: relative;\n            float: left;\n            height: 46px;\n            display: inline-block;\n            text-align: center;\n            padding: 0 20px 0 30px;\n            margin: 0;\n            font-size: 16px;\n            line-height: 46px;\n            background-color: #f9f9f9;\n\n            width: 100%;\n            padding: 0;\n            box-sizing: content-box;\n            border-bottom: 1px solid #d4d4d4;\n            &:last-child {\n                box-sizing: border-box;\n            }\n\n\n            a {\n                color: $ac-text-color-blue;\n                padding: 0;\n            }\n            a:hover {\n                background-color: transparent;\n            }\n            &:before {\n                position: absolute;\n                display: block;\n                border: 24px solid transparent;\n                z-index: 1;\n                content: '';\n                    border-top: 8px solid #d4d4d4;\n                    border-bottom: 0;\n                    left: 50%;\n                    margin-left: -24px;\n                    bottom: -9px;\n\n            }\n            &:after {\n                position: absolute;\n                display: block;\n                z-index: 1;\n                content: '';\n                border: 24px solid transparent;\n\n                    border-top: 8px solid #f9f9f9;\n                    border-bottom: 0;\n                    left: 50%;\n                    margin-left: -24px;\n                    bottom: -8px;\n\n            }\n\n            &.disabled:after {\n\n                    border-top: 8px solid #f9f9f9;\n\n            }\n\n            &.disabled a,\n            &.disabled a:active,\n            &.disabled a:visited,\n            &.disabled a:focus {\n                color: #999999;\n                background: #f9f9f9;\n            }\n\n            &:last-child {\n                margin-bottom: -1px\n            }\n\n\n            &.active {\n                background: $ac-color-primary-blue;\n            }\n            &.active:after {\n                   border-top: 8px solid $ac-color-primary-blue;\n\n            }\n            &.active a,\n            &.active a:active,\n            &.active a:visited,\n            &.active a:focus {\n                color: #fff;\n                background: $ac-color-primary-blue;\n            }\n\n            &.label-on-two-lines {\n                // max-width: 150px;\n                // line-height: 1.2;\n                // padding-top: 4px;\n            }\n        }\n\n        .active ~ li {\n            color: #999999;\n            background: #f9f9f9;\n        }\n        .active ~ li:after {\n                border-top: 8px solid #f9f9f9;\n\n        }\n    }\n\n    &.horizontal {\n\n        margin-bottom: 30px;\n        overflow: hidden;\n        color: lightgrey;\n\n        &.active {\n            color: #000000\n        }\n\n        li {\n            list-style-type: none;\n            font-size: 12px;\n            width: 12%;\n            float: left;\n            position: relative;\n            text-align: center;\n        }\n\n        #creditCard:before {\n            font-family: \"Font Awesome 7 Free\";\n            font-size: 900;\n            content: \"\\f023\"\n        }\n        #eft:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f023\"\n        }\n\n        #pricing:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f007\"\n        }\n\n        #identification:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f09e\"\n        }\n\n        #shareholder:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f001\"\n        }\n        #configuration:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f002\"\n        }\n        #usageFees:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f003\"\n        }\n        #appendicesSignature:before {\n            font-size: 900;\n            font-family: \"Font Awesome 7 Free\";\n            content: \"\\f004\"\n        }\n\n        li:before {\n            width: 50px;\n            height: 50px;\n            line-height: 45px;\n            display: block;\n            font-size: 18px;\n            color: #ffffff;\n            background: lightgray;\n            border-radius: 50%;\n            margin: 0 auto 10px auto;\n            padding: 2px\n        }\n\n        li:after {\n            content: '';\n            width: 100%;\n            height: 2px;\n            background: lightgray;\n            position: absolute;\n            left: 0;\n            top: 25px;\n            z-index: -1\n        }\n\n        li.active:before,\n        li.active:after {\n            background: skyblue\n        }\n    }\n}\n\n","$header-height: 68px;\n$sub-navbar-height: 40px;\n$footer-height: 50px;\n$footer-height-mob: 57px;\n$screen-xxs-bottom: 0px;\n$screen-xxs-top: 400px;\n$screen-xs-bottom: 401px;\n$screen-xs-top: 767px;\n$screen-sm-bottom: 768px;\n$screen-sm-top: 991px;\n$screen-md-bottom: 992px;\n$screen-md-top: 1199px;\n$screen-lg-bottom: 1200px;\n\n// Colors\n$ac-color-primary-blue: #1E95D3;\n$ac-color-primary-dark-grey: #3A3C3D;\n$ac-color-primary-light-grey: #B6B7B6;\n\n$ac-color-secondary-dark-blue: #003F72;\n$ac-color-secondary-light-blue: #0CC6DE;\n$ac-color-secondary-light-green: #8FAD15;\n$ac-color-secondary-dark-green: #206C49;\n$ac-color-secondary-dark-purple: #412D5D;\n$ac-color-secondary-light-purple: #A30050;\n$ac-color-secondary-orange: #E35205;\n$ac-color-secondary-beige: #C7B37F;\n$ac-color-secondary-red: #a94442;\n\n// Text colors\n$ac-text-color-blue: #2695ce;\n$ac-text-color-dark-grey: #404245;\n$ac-text-color-light-grey: #b6b9b9;\n\n// Fonts\n$ac-font-family-sans-serif: \"Open Sans\",\"Helvetica Neue\",sans-serif;\n$ac-font-base: 16px;\n\n// Header\n$ac-header-vertical-margin: 20px;\n$ac-header-horizontal-margin: 15px;\n$ac-header-max-height: 90px;\n$ac-header-font-size: 14px;\n\n// Navbar\n$ac-navbar-font-size: 18px;\n\n// Buttons\n$ac-button-border-radius: 20px;\n$ac-button-font-weight: bold;\n$ac-button-font-size: 16px;\n$ac-button-height: 40px;\n$ac-button-text-transform: none;\n$ac-button-vertical-padding: 12px;\n$ac-button-min-width: 200px;\n\n// Header buttons\n$ac-button-header-font-size: 18px;\n$ac-button-header-text-transform: uppercase;\n$ac-button-header-min-width: initial;\n\n// Links\n$ac-link-color: $ac-text-color-blue;\n$ac-link-color-visited: $ac-color-secondary-dark-blue;\n\n\n$header-height: 68px;\n$sub-navbar-height: 40px;\n$footer-height: 50px;\n$footer-height-mob: 57px;\n$screen-xxs-bottom: 0px;\n$screen-xxs-top: 400px;\n$screen-xs-bottom: 401px;\n$screen-xs-top: 767px;\n$screen-sm-bottom: 768px;\n$screen-sm-top: 991px;\n$screen-md-bottom: 992px;\n$screen-md-top: 1199px;\n$screen-lg-bottom: 1200px;\n\n$input-focus-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
